import { API_URL } from '../api/config';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function subscreverPush(token, institutionId = null) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    throw new Error('Seu navegador não suporta notificações em segundo plano.');
  }

  const permissao = await Notification.requestPermission();
  if (permissao !== 'granted') {
    throw new Error('Permissão de notificação não foi concedida.');
  }

  // Registra explicitamente o service-worker caso ainda não esteja ativo
  await navigator.serviceWorker.register('/service-worker.js');
  const reg = await navigator.serviceWorker.ready;

  const vapidKey =
    process.env.REACT_APP_VAPID_PUBLIC_KEY ||
    'BMU6_-MQSGbI1cD8ohR3hHyAg6ryDtzvOL0RAb0VWQBay4bR8G2nqV5T_tcRGXvbXmDWVizpkxRHag8F1XbT5kE';

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidKey),
    });
  }

  const idInst = institutionId || localStorage.getItem('selectedInstitutionId');
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };

  if (idInst) {
    headers['x-institution-id'] = String(idInst);
  }

  const res = await fetch(`${API_URL}/api/notificacoes/push/inscrever`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ subscription: sub }),
  });

  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.error || data.message || 'Falha ao salvar inscrição no servidor.');
  }

  return data;
}
